import { createContext , useState } from "react";

export const DonateContext = createContext();
export const DonateProvider = ({children}) => {
    const [isDonateOpen, setIsDonateOpen] = useState(null);
    return (
        <DonateContext.Provider value={{isDonateOpen, setIsDonateOpen}}>
            {children}
        </DonateContext.Provider>
    )
}